import { Layout, Modal } from 'antd'
import { Redirect, Route, Switch, useHistory } from 'react-router-dom'

import React, { useEffect, useCallback, Component } from 'react'

import HomeInfo from '../HomeInfo'

import CommonHeader from '../CommonHeader'

import './basic-layout.less'
import { MEvents, REFRESH_TOKEN, TOKEN, USER_INFO } from '../../api/constants'
import Grades from '../CourseOutline'
import CourseCom from '../Course'
import UserCom from '../User'
import NewsCom from '../News'
import ResourceCom from '../Resource'
import AitoolsCom from '../AiTools'
import TrainCom from '../Train'
import Preview from '../Preview'
import MatchPage from 'components/Match/match'
import AgreementCom from '../Agreement'
import { useDispatch } from 'react-redux'
import { saveUser } from 'reducers/user'
import EvaluationPage from 'pages/EvaluationPage/evaluation'
import { SetCurrentGrade } from 'reducers/course'
import EvaluationPaperPage from 'pages/EvaluationPage/paper'
import EvaluationResultPage from 'pages/EvaluationPage/evaluationResult'
import AiToolInfoCom from 'components/AiToolInfo'

const { Header, Content } = Layout

const BasicLayout = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  useEffect(() => {
    const handleTokenError = () => {
      if (sessionStorage.getItem(MEvents.TokenError) !== null) {
        return
      }
      sessionStorage.setItem(MEvents.TokenError, '1')

      Modal.warning({
        title: '登录超时',
        content: <div>由于长时间未操作，请重新登录。</div>,
        onOk() {
          sessionStorage.removeItem(TOKEN)
          sessionStorage.removeItem(REFRESH_TOKEN)
          history.push('/login')
          sessionStorage.removeItem(MEvents.TokenError)
        },
      })
    }

    window.addEventListener(MEvents.TokenError, handleTokenError)

    const handleLoginByAnotherOne = () => {
      if (sessionStorage.getItem(MEvents.LoginByAnotherOne) !== null) {
        return
      }
      sessionStorage.setItem(MEvents.LoginByAnotherOne, '1')

      Modal.warning({
        title: '账号被他人登录',
        content: <div>该账号已被他人登录。</div>,
        onOk() {
          sessionStorage.removeItem(TOKEN)
          sessionStorage.removeItem(REFRESH_TOKEN)
          history.push('/login')
          sessionStorage.removeItem(MEvents.LoginByAnotherOne)
        },
      })
    }

    window.addEventListener(MEvents.LoginByAnotherOne, handleLoginByAnotherOne)

    window.addEventListener('load', () => {
      // 重新注入用户信息
      const userInfo = sessionStorage.getItem(USER_INFO)
      if (userInfo !== null) {
        dispatch(saveUser(JSON.parse(userInfo)))
      }
      const currentGrade = sessionStorage.getItem('CurrentGrade')
      if (currentGrade) {
        dispatch(SetCurrentGrade(JSON.parse(currentGrade)))
      }
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history])

  const onEnterCourse = useCallback((Component, props) => {
    return <Component {...props} />
  }, [])

  const onEnterAiTool = useCallback((Component, props) => {
    return <Component {...props} />
  }, [])

  return (
    <Layout className="main">
      <Header className="layout-header">
        <CommonHeader />
      </Header>
      <Content className="layout-content">
        <Switch>
          <Redirect exact from="/" to="/home" />
          <Route exact path="/home" component={HomeInfo}></Route>
          <Route path="/grades/:id" component={Grades}></Route>
          <Route path="/courses/:id" render={props => onEnterCourse(CourseCom, props)}></Route>
          <Route path="/aitools/:id" render={props => onEnterAiTool(AiToolInfoCom, props)}></Route>
          <Route path="/preview/:id" component={Preview} />
          <Route path="/user" component={UserCom}></Route>
          <Route exact path="/evaluation" component={EvaluationPage} />
          <Route exact path="/evaluation/result" component={EvaluationResultPage} />
          <Route exact path="/evaluation/paper/:id" component={EvaluationPaperPage} />
          <Route exact path="/news" component={NewsCom} />
          <Route exact path="/resource" component={ResourceCom} />
          <Route exact path="/aitools" component={AitoolsCom} />
          <Route exact path="/training" component={TrainCom} />
          <Route exact path="/match" component={MatchPage} />
          <Route exact path="/agreement" component={AgreementCom} />
        </Switch>
      </Content>
      {/* <Footer></Footer> */}
    </Layout>
  )
}

export default BasicLayout
